'use client'
import React, { useState, useEffect } from 'react'
import LargeProjectCard from '@components/LargeProjectCard'
// import SearchMap from '@components/SearchMap'
// import MobileSearchMap from '@components/MobileSearchMap'
// import MobileMapPropertyCard from '@components/MobileMapPropertyCard'
import { getFilteredProjects } from '@services/getFilteredProjects'

// import { useSession } from 'next-auth/react'
import { saleTypes } from '@constants/saleTypes'

import 'swiper/css';
import 'swiper/css/navigation';

const SearchResultCards = ({ searchParams, dictionary, lang = 'en' }) => {

  
    // const { data: session } = useSession()
    let userEmail = null

    // const [currency, setCurrencyType] = useState('thb')
    const [search, setSearch] = useState(searchParams)
    const [page, setPage] = useState(1);
    const [allPages, setAllPages] = useState(1);

    const [projects, setProjects] = useState([]);
    const [propertyCount, setPropertyCount] = useState(0);
    // const [showMap, setShowMap] = useState(false)
    const [coordinates, setCoordinates] = useState([])
    const [hoveredProperty, setHoveredProperty] = useState(null)
    const [activeProperty, setActiveProperty] = useState({})
    const [activePropertyLat, setActivePropertyLat] = useState(13.732772)
    const [activePropertyLng, setActivePropertyLng] = useState(100.5801953)

    // if (session !== null) {
    //     userEmail = session?.user?.email
    // }

    const handleMouseEnter = (propertyId) => {
        // console.log(e)
        // console.log('hover ' + propertyId)
        setHoveredProperty(propertyId)
    };
    const handleMouseLeave = () => {
        // console.log('hover end')
        setHoveredProperty(null)
    };

    const handleSlideChange = (swiper) => {
        // Emit your event or perform actions when the active slide changes
        const activeSlideIndex = swiper.activeIndex;
        // console.log(`Active slide index: ${activeSlideIndex}`);
        // let activePropertyId = swiper.slides[activeSlideIndex].id
        // let activePropertyLat = swiper.slides[activeSlideIndex].dataset.latitude
        // let activePropertyLng = swiper.slides[activeSlideIndex].dataset.longitude
        // setActiveProperty(activePropertyId)
        // setActivePropertyLat(activePropertyLat)
        // setActivePropertyLng(activePropertyLng)

        // Emit an event or perform actions here
    };

    const getData = async (pageNumber) => {
        const result = await getFilteredProjects({
            // saleType: searchParams.saleType || saleTypes[lang][0].value,
            // bts: searchParams.bts || '',
            // district: searchParams.district || '',
            // location: searchParams.location || '',
            // project: searchParams.project || '',
            category: searchParams.category || '',
            // minBedrooms: searchParams.minBedrooms || '',
            // maxBedrooms: searchParams.maxBedrooms || '',
            // room: searchParams.room || '',
            // currency: searchParams.currency || 'thb',
            // minprice: searchParams.minprice || '',
            // maxprice: searchParams.maxprice || '',
            // petfriendly: searchParams.petfriendly || '',
            // seaview: searchParams.seaview || '',
            // beachfront: searchParams.beachfront || '',
            // map: searchParams.map || false,
            sort: searchParams.sort || 'datedesc',
            // limit: searchParams.limit || 10,
            page: pageNumber
        },
            userEmail
        )

        // console.log(result)

        if (pageNumber > 1) {
            setProjects((prev) => [...prev, ...result.projects])
        } else {
            setProjects(result.projects)
        }
        setAllPages(result.pages)
        setPropertyCount(result.count)
        setCoordinates(result.coordinates)
        if (result.projects.length > 0 && page == 1) {
            setActiveProperty(result.projects[0].id)
            // setActivePropertyLat(Number(result.projects[0].latitude))
            // setActivePropertyLng(Number(result.projects[0].longitude))
        }
    }

    useEffect(() => {
        setPage(1)
        setProjects([])
        // setShowMap(searchParams.map)

        getData(1)
    }, [searchParams])

    useEffect(() => {
        getData(page)
    }, [page])

    return (
        <div className='md:w-full 2xl:w-10/12 max-w-[1600px] flex md:flex-row flex-col flex-nowrap md:flex-wrap mx-auto md:px-3 px-0'>
            <>
                {projects.map((project, index) => (
                    <div
                        key={project.id}
                        className='m-2'
                    >
                        <LargeProjectCard
                            dictionary={dictionary.card}
                            lang={lang}
                            project={project}
                            isLast={index === projects.length - 1}
                            imageWidth={320}
                            newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                        />
                    </div>
                ))}
            </>
        </div>
    )
}

export default SearchResultCards